module.exports = __webpack_public_path__ + "img/envelope.90c6bc57.svg";